import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { filterNamedPersonas } from "@/app/utils/userPersona";

export interface ICouponUserPersonaResponse {
  status: boolean;
  message: string;
  data: Array<string>;
}

AxiosCurlirize(axios, () => {});

export const useCouponUserPerSonaListAPI = () => {
  const [userpersona, setUserpersona] = useState<Array<string>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(async () => {
    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(COUPON_SERVICE_APIS?.USERPERSONA_LIST_API?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICouponUserPersonaResponse>) => {
          if (res.data.status) {
            setUserpersona(filterNamedPersonas(res.data.data));
          } else {
            setUserpersona([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            setUserpersona([]);
            //   toast.error("Error while fetching List details");
          }
          if (e.status === 400) {
            setUserpersona([]);
            //   toast("Product records not found");
          }

          if (e.response.status === 500) {
            setUserpersona([]);
            // toast.error("Server error 500");
          }
        });
    } catch (e: any) {
      // toast.error("Server Error: " + e.message);
      setUserpersona([]);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);
  return { execute, userpersona, isLoading };
};
